import { RuleInterface } from '@vendasta/automata';

export function TriggerBaseRules(
  target: unknown,
  propertyKey: string,
  descriptor: TypedPropertyDescriptor<any>,
): TypedPropertyDescriptor<any> {
  const triggerGetBaseRulesMethod = descriptor.value; // save a reference to the original method

  // NOTE: Do not use arrow syntax here. Use a function expression in
  // order to use the correct value of `this` in this method (see notes below)
  descriptor.value = function (args: RuleInterface[]): RuleInterface[] {
    // Run getBaseRules method
    const triggerRules = triggerGetBaseRulesMethod.apply(this, args) as RuleInterface[];

    // Apply next step to any trigger rules using this decorator
    try {
      if (!triggerRules || triggerRules?.length === 0) {
        throw new Error(`
          A trigger must have one rule.
          It's not possible to move to the next step if a rule doesn't exist for it.
          Check <a href="https://github.com/vendasta/automata/blob/master/sdks/typescript/src/automata_sdk/src/lib/rule.ts">the rules SDK</a> for more information
        `);
      }

      if (triggerRules?.length > 1) {
        throw new Error(`
          Only one rule per trigger is currently supported.
          Did you want to use an 'And' or 'Or' rule instead?
          Check <a href="https://github.com/vendasta/automata/blob/master/sdks/typescript/src/automata_sdk/src/lib/rule.ts">the rules SDK</a> for more information
        `);
      }
      return triggerRules;
    } catch (err) {
      console.error(err);
      return triggerRules;
    }
  };

  return descriptor;
}
